import { Box, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import DropDownOA from '../../../common/dropDownOA'
import BranchMasterTable from './BranchMasterTable'
import BrnchMasterModal from './BrnchMasterModal'
import * as mdt from '../../../common/modaltypes'
import { connect } from 'react-redux'
import { getPrintFormatList, updateModal } from '../../../../store/common/common_action'
import { clickElement, createCommaSeparatedString, focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { statusOpt } from './BrnchMasterConstant'
import { getBranchDetails, getStateList, getCityList, updateModalHeaderDropDownData, getBranchData, getBranchDirectoryData, updateBrnhDirectoytData } from '../../../../store/branchAndUserMaster/BUMAction'
import BranchMAsterExcelTable from './BranchMAsterExcelTable'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { PostRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { useAtom } from 'jotai'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'

const BranchMaster = (props) => {
    const { data: { common, branchAndUserMasterReducer },
        updateModal,
        getBranchDetails,
        getStateList,
        getCityList,
        updateModalHeaderDropDownData,
        getBranchData,
        getBranchDirectoryData,
        updateBrnhDirectoytData,
        getPrintFormatList,
        loginData,
        FromUrlRedirect
    } = props
    const {  showModal, modalType, waybillFormats } = common
    const {  ModalHeaderDropDownData } = branchAndUserMasterReducer
    const [selStatus, setSelStatus] = useState(statusOpt[1])
    const [tableData, setTableData] = useState([])
    const [showTable, setShowTable] = useState(false)
    const [selEditBranch, setSelEditBranch] = useState('')
    const [stateOptList, setStateOptList] = useState([])
    const [cityOptList, setCityOptList] = useState([])
    const [excelTableData, setExcelTableData] = useState([])
    const [BranchDetailsList, setBranchDetailsList] = useState([])
    const [, setLoader] = useAtom(globalLoaderAtom)
    const [, setAlert] = useAtom(alertAtom)
    const [modal, setModal] = useAtom(modalAtom)

    useEffect(() => {
        focusElemnt('status')
    }, [])
    const createNewBranchMaster = () => {
        let data = {
            headText: "Create/Edit Branch",
            BranchId: '',
            isEdit: false,
            BranchList: BranchDetailsList,
            stateList: stateOptList,
            cityList: cityOptList,
            loginData: loginData,
            dropDownData: ModalHeaderDropDownData
        }
        return <BrnchMasterModal data={data} updateBrnhDirectoytData={updateBrnhDirectoytData} getBranchDirectoryData={getBranchDirectoryData} getBranchData={getBranchData} updateModalHeaderDropDownData={updateModalHeaderDropDownData} updateModal={updateModal} FromUrlRedirect={FromUrlRedirect} loginData={loginData} />
    }
    const editBranchMaster = () => {
        let data = {
            headText: "Create/Edit Branch",
            BranchId: selEditBranch,
            isEdit: true,
            BranchList: BranchDetailsList,
            stateList: stateOptList,
            cityList: cityOptList,
            loginData: loginData,
            dropDownData: ModalHeaderDropDownData
        }
        return <BrnchMasterModal data={data} updateBrnhDirectoytData={updateBrnhDirectoytData} getBranchDirectoryData={getBranchDirectoryData} getBranchData={getBranchData} updateModalHeaderDropDownData={updateModalHeaderDropDownData} updateModal={updateModal} FromUrlRedirect={FromUrlRedirect} loginData={loginData} />
    }
    useEffect(() => {
        if (loginData?.intCompanyID !== 'undefined') {
            fetchBranchData()
            getStateOptList()
            getCityOptList()
        }
    }, [loginData?.intCompanyID])


    const resetAllValue = () => {
        setTableData([])
        setShowTable(false)
    }
    const getStateOptList = () => {
        let body = {
            StateID: 0,
        }
        getStateList(body, true, 24 * 60 * 60 * 1000).then((res) => {
            if (res.status === 'Success') {
                setStateOptList(res.Data.Table)
            } else {
                setStateOptList([])
            }
        }).catch((err) => {
            console.log('Error:', err)
        })

    }
    const getCityOptList = () => {
        let body = {
        }
        getCityList(body, true, 24 * 60 * 60 * 1000).then((res) => {
            if (res.status === 'Success') {
                setCityOptList(res.Data.Table)
            } else {
                setCityOptList([])
            }
        }).catch((err) => {
            console.log('Error:', err)
        })
    }
    const fetchBranchData = async () => {
      resetAllValue()
      setLoader(true)
      const body = {
        intUserID: 0,
        intCompanyID: loginData.intCompanyID,
        intBranchID: 0,
        strBranchName: '',
        strBranchCode: '',
        intStateID: 0,
        intCityID: 0,
        intIsActive: -1,
      }
      try {
        const res = await PostRequest(urls.getBranchConfigOrEwbillinfo, body)
        if (res.status === 'Success') {
          const list = res?.Data?.Table || []
          setBranchDetailsList(list)
          const filterList = list.filter((val) => selStatus?.id === -1 || val?.IsActive === selStatus?.id)
          setTableData(filterList)
          setShowTable(true)
        } else {
          setAlert({ show: true, msg: res.ErrMessage })
        }
      } catch (error) {
        console.log('Error:', error)
      } finally {
        setLoader(false)
      }
    }
    useEffect(() => {
        if (loginData.intCompanyID) {
            getPrintFormatList(loginData.intCompanyID)
          }
        }, [loginData.intCompanyID])
  
    useEffect(() => {
        if (excelTableData?.length > 0) {
            clickElement('xls-buttons')
        }
    }, [excelTableData])
    const generateExcel = () => {
        if (tableData?.length > 0 && selStatus?.id !== -1) {
            let newData = tableData?.map((item) => {

                const bkngPrintCopyArr = [];
                if (item?.IsBookingCustomerCopy === 1) {
                    bkngPrintCopyArr.push('Customer Copy');
                }
                if (item?.IsBookingBranchCopy === 1) {
                    bkngPrintCopyArr.push('Branch Copy');
                }
                if (item?.IsBookingDriverCopy === 1) {
                    bkngPrintCopyArr.push('Driver Copy');
                }

                const bkngPrintCopyTemp = bkngPrintCopyArr.join(', ');
                const delPrintCopyArr = [];
                if (item?.IsDeliveryCustomerCopy === 1) {
                    delPrintCopyArr.push('Customer Copy');
                }
                if (item?.IsDeliveryBranchCopy === 1) {
                    delPrintCopyArr.push('Branch Copy');
                }
                if (item?.IsDeliveryDriverCopy === 1) {
                    delPrintCopyArr.push('Driver Copy');
                }
                const delPrintCopyTemp = delPrintCopyArr.join(', ');
                //penalty section
                let penaltyType = 'NA';
                let penaltyChargeType = 'NA';
                let chargeVal = 'NA'
                if (item?.IsLRPenaltyOnFreight === 1) {
                    penaltyType = 'Penalty On Freight';
                    if (item?.ChargeType?.['id'] === 1) {
                        penaltyChargeType = 'Percentage';
                        chargeVal = item?.LRPenaltyOnFreightPer;
                    } else if (item?.ChargeType?.['id'] === 2) {
                        penaltyChargeType = 'Amount';
                        chargeVal = item?.LRPenaltyOnFreightAmt;
                    }
                } else if (item?.IsDocChgAsLrPenalty === 1) {
                    penaltyType = 'Penalty Doc. Charge';
                }
                return {
                    ...item,
                    isCreditLimit: item?.IsCargoCreditLimit === 1 ? 'Yes' : 'No',
                    creditLimitVal: item.CargoCreditLimit > 0 ? 'Limited' : 'Unlimited',
                    stopBkngType: (item.CreditLimitPayType?.['id'] === 1 || item.CreditLimitPayType === 1) ? 'Paid Only' : (item.CreditLimitPayType?.['id'] === 2 || item.CreditLimitPayType === 2) ? 'Paid & ToPay' : '',
                    //gst data
                    isGST: 'Yes',
                    cgst: item?.CargoHasCGST === 1 ? 'Yes' : 'No',
                    sgst: item?.CargoHasSGST === 1 ? 'Yes' : 'No',
                    igst: item?.CargoHasIGST === 1 ? 'Yes' : 'No',
                    //Penalty Data
                    penaltyType: penaltyType,
                    penaltyChargeType: penaltyChargeType,
                    chargeValue: chargeVal,
                    penaltyAfterMin: item?.IsLRPenaltyOnFreight === 0 && item?.IsDocChgAsLrPenalty === 0 ? 'NA' : item?.PenaltyAfterMinutes,

                    //commissiondata
                    comissionVal: 'Yes',
                    ptlCommVal: 'Yes',
                    ftlCommVal: 'Yes',
                    //frieght data
                    isMinFreight: item?.IsMinFreightPerParcel === 1 ? 'Yes' : 'No',
                    isMaxFreight: item?.IsMaxFreightPerParcel === 1 ? 'Yes' : 'No',
                    //print data
                    bkngPrintOptions: createCommaSeparatedString(
                        waybillFormats?.filter((val) => val?.FormatID === item?.CargoStandardTicketFormatID),
                        'FormatName'
                    ),
                    bkngPrintCopy: bkngPrintCopyTemp,  // Assign the built comma-separated string
                    DelPrintOptions: createCommaSeparatedString(
                        waybillFormats?.filter((val) => val?.FormatID === item?.DeliveryPrintFormatID),
                        'FormatName'
                    ),
                    delPrintCopy: delPrintCopyTemp,
                    //checkbox data
                    CargoHasSTaxOfflineBooking: item?.CargoHasSTaxOfflineBooking === 1 ? 'Yes' : 'No',
                    CargoHasCrossing: item?.CargoHasCrossing === 1 ? 'Yes' : 'No',
                    IsCargoGodownBranch: item?.IsCargoGodownBranch === 1 ? 'Yes' : 'No',
                    CargoHasSticker: item?.CargoHasSticker === 1 ? 'Yes' : 'No',

                    CargoHasBranchReceive: item?.CargoHasBranchReceive === 1 ? 'Yes' : 'No',
                    CargoHasDelivery: item?.CargoHasDelivery === 1 ? 'Yes' : 'No',
                    CargoHasDeliveryManual: item?.CargoHasDeliveryManual === 1 ? 'Yes' : 'No',
                    AcceptBusLuggage: item?.AcceptBusLuggage === 1 ? 'Yes' : 'No',

                    AcceptCargoLuggage: item?.AcceptCargoLuggage === 1 ? 'Yes' : 'No',
                    CargoAllowToPayBooking: item?.CargoAllowToPayBooking === 1 ? 'Yes' : 'No',
                    DisablePickupCartage: item?.DisablePickupCartage === 1 ? 'Yes' : 'No',
                    DisableDeliveryCartage: item?.DisableDeliveryCartage === 1 ? 'Yes' : 'No',

                    IsPhotoIDProofCompulsory: item?.IsPhotoIDProofCompulsory === 1 ? 'Yes' : 'No',
                    IsSenderIDProof: item?.IsSenderIDProof === 1 ? 'Yes' : 'No',
                    DisablePhotoIDUpload: item?.DisablePhotoIDUpload === 1 ? 'Yes' : 'No',
                }

            })
            newData?.sort((a, b) => a.BranchID - b.BranchID);
            setExcelTableData(newData)
        }
    }
    return (
        <>
            <Box sx={sx.reportFlex} className='reportButton'>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label={'Company Name'}
                        id='companyName'
                        defaultvalue={loginData.strCompanyName}
                        disabled={true}
                        minWidth="250px"
                        nextId={'status'}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label={'Status'}
                        id={'status'}
                        data={statusOpt || []}
                        defaultvalue={selStatus?.name || selStatus}
                        value={selStatus?.name || selStatus}
                        onSelect={(val) => {
                            resetAllValue()
                            setSelStatus(val)
                        }}
                        noCross={true}
                        onReset={() => {
                            resetAllValue()
                            setSelStatus('')
                        }}
                        idKey={`id`}
                        dataKey={`name`}
                        minWidth="250px"
                        nextId={'loadBtn'}
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button variant="contained" id={'loadBtn'} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
                        onKeyDown={(e) => {
                            navigation3(e, 'createBtn', 'status', () => { })
                        }}
                        onClick={() => fetchBranchData()}
                    >
                        LOAD
                    </Button>
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button variant="outlined" id='createBtn' sx={{ width: '100%' }} className="receiveitembtn"
                        onClick={() => {
                            updateModal(true, mdt.createNewBranchMaster)
                        }}
                        onKeyDown={(e) => {
                            navigation3(e, `Contains-1`, 'loadBtn', () => { })
                        }}
                    >
                        CREATE NEW BRANCH
                    </Button>
                </Item>
                {selStatus?.id !== -1 &&
                    <Box >
                        <Button id='view-xls-button' variant="outlined" sx={{ width: '100%', fontSize: '16px', color: '#fe5200' }} className="receiveitembtn"
                            onClick={(e) => { generateExcel() }}
                            // onKeyDown={(e) => {
                            //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                            // }}

                            style={{ width: '100%' }}
                        >
                            EXCEL
                        </Button>
                        <ReactHtmlTableToExcel
                            id="xls-buttons"
                            table="cityPairExelTbl"
                            filename={'Branch Master'}
                            sheet="sheet 1"
                            buttonText=" EXCEL"
                            className="excel-button"
                        />
                    </Box>}
            </Box>
            {showTable &&
                <Box sx={sx.reportFlex}>
                    <BranchMasterTable setSelEditBranch={setSelEditBranch} tableData={tableData} updateModal={updateModal} modalType={modalType} showModal={showModal} loginData={loginData} />
                </Box>
            }
            {showTable &&
                <Box sx={sx.reportFlex}>
                    <BranchMAsterExcelTable tableData={excelTableData} loginData={loginData} />
                </Box>
            }
            {showModal && mdt.createNewBranchMaster === modalType ? createNewBranchMaster() : null}
            {showModal && mdt.editBranchMaster === modalType ? editBranchMaster() : null}
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, getBranchDetails, getStateList, getCityList, updateModalHeaderDropDownData, getBranchData, getBranchDirectoryData, updateBrnhDirectoytData, getPrintFormatList }
export default connect(mapStateToProps, mapDispatchToProps)(BranchMaster)